<gpf-gene-profiles-table
  *ngIf="geneProfilesTableConfig"
  (goToQueryEvent)="goToQueryEventHandler($event)"
  (resetConfig)="resetConf()"
  [config]="geneProfilesTableConfig">
</gpf-gene-profiles-table>
